module.exports = __webpack_public_path__ + "static/media/04.dcf0ba64.mp3";